import React from "react";

import { Text, Image, Appear, Slide, Code } from "spectacle";
import { CustomHeading } from "../../../custom-style";

const image = require("./images/test-coverage.png");

export default () => {
  return (
    <Slide>
      <CustomHeading>Cobertura de código</CustomHeading>
      <Appear>
        <Image src={image} />
      </Appear>
    </Slide>
  );
};



// WEBPACK FOOTER //
// ./src/slides/02-unit-testing/02-core-concepts/11-code-coverage.js